"use client";
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import useWindowDimensions from "@/next-src/hooks/useWindowDimensions";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";
import Accordion from "@/next-src/components/ui/accordion/Accordion";
import ResponsiveImage from "@/next-src/components/ui/responsive-image/ResponsiveImage";
import getResponsiveEl from "@/next-src/utils/getResponsiveEl";

import comCSS from "./Team.module.scss";

const Team = ({ className = "", data = {} }) => {
  const { width: windowWidth } = useWindowDimensions();

  const {
    preTitleMobile,
    titleMobile,
    textMobile,
    bgColorMobile,
    departments,
  } = data || {};

  let { preTitle, title, text, bgColor } = data || {};

  if (windowWidth < 992) {
    preTitle = preTitleMobile;
    title = titleMobile;
    text = textMobile;
    bgColor = bgColorMobile;
  }

  const getAccordionData = (accData) =>
    accData
      ?.filter((el) => !el.hide)
      ?.map((el) => ({
        id: el.id,
        header: (
          <>
            <div className="dropdown-image">
              <ResponsiveImage
                width={80}
                height={80}
                lazyLoading
                sizes="80px"
                alt={el.image?.alt}
                src={el.image?.src}
                className="cover-image"
              />
            </div>
            <div className="team-name-position-wrap">
              <div>{convertHTMLtoJSX(el.name)}</div>
              {el.position && (
                <div className="small-tag grey">
                  <div>{convertHTMLtoJSX(el.position)}</div>
                </div>
              )}
            </div>
          </>
        ),
        body: (
          <div className="max-width-medium">{convertHTMLtoJSX(el.bio)}</div>
        ),
      }));
  return (
    <section
      className={cn(
        "section background-color-soft-blue",
        className,
        comCSS.wrapper
      )}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <div className="padding-global">
        <div className="container-large">
          <div className="padding-section-large">
            <div className="margin-bottom margin-medium">
              <div className="section_heading-wrapper">
                <div className="section_heading">
                  <div className="max-width-large">
                    <div className="margin-bottom margin-xsmall">
                      <div className="text-note">
                        {convertHTMLtoJSX(preTitle)}
                      </div>
                    </div>
                    <div className="margin-bottom margin-xsmall">
                      {convertHTMLtoJSX(title)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {departments
              ?.filter((el) => !el.hide)
              ?.map((el) => (
                <div key={el.id} className="dropdown_list">
                  <div className="team-category-wrap">
                    <div>
                      {convertHTMLtoJSX(
                        getResponsiveEl(windowWidth, el, "title", "titleMobile")
                      )}
                    </div>
                    <h4 fs-countitems-element="value-3">{el.team?.length}</h4>
                  </div>
                  <Accordion
                    data={getAccordionData(el.team)}
                    isReadMore
                    itemClassName="first-with-top-line"
                    bodyClassName="team"
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

Team.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    preTitle: PropTypes.string,
    preTitleMobile: PropTypes.string,
    title: PropTypes.string,
    titleMobile: PropTypes.string,
    text: PropTypes.string,
    departments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        titleMobile: PropTypes.string,
        teams: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            position: PropTypes.string,
            image: PropTypes.shape({
              id: PropTypes.string,
              src: PropTypes.string,
              alt: PropTypes.string,
            }),
            bio: PropTypes.string,
          })
        ),
        hide: PropTypes.bool,
      })
    ),
    bgColor: PropTypes.string,
    bgColorMobile: PropTypes.string,
  }),
};

export default Team;
